import MuiSkeleton from '@mui/material/Skeleton'
import { skeletonStyles } from './Skeleton.styles'

interface SkeletonProps {
  width?: number | string
  height?: number | string
  variant?: 'text' | 'rounded' | 'circular'
}

function Skeleton(props: SkeletonProps) {
  const { width = '100%', height = '100%', variant = 'rounded' } = props

  return (
    <MuiSkeleton
      sx={{
        ...skeletonStyles,
        fontSize: variant === 'text' ? height : undefined
      }}
      variant={variant}
      width={width}
      height={height}
    />
  )
}

export default Skeleton
